import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

function ClientPage() {
  const [imageFrame, setImageFrame] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isPolling, setIsPolling] = useState(false);

  // Function to fetch client data
  const fetchClientData = useCallback(async () => {
    try {
    //   const response = await fetch('http://localhost:5001/api/client-data');
      const response = await axios.get('http://localhost:5001/api/client-data');
      const data = response.data;
      
      if (data.success && data.imageFrame) {
        setImageFrame(data.imageFrame);
        setError(null);
      } else {
        setError(data.message || 'No frame data available');
        setImageFrame(null);
      }
    } catch (err) {
      setError('Failed to connect to server');
      setImageFrame(null);
      console.error('Error fetching client data:', err);
    } finally {
      setLoading(false);
    }
  }, []);

  // Initial fetch on component mount
  useEffect(() => {
    fetchClientData();
  }, [fetchClientData]);

  // Polling function for real-time updates
  useEffect(() => {
    let intervalId;
    
    if (isPolling) {
      intervalId = setInterval(() => {
        fetchClientData();
      }, 1000); // Poll every second
    }
    
    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [isPolling, fetchClientData]);

  const togglePolling = () => {
    setIsPolling(!isPolling);
  };

  return (
    <div className="client-page">
      <div className="container">
        <h1>Client Page</h1>
        <p>Welcome to the client interface!</p>
        
        <div className="content-area">
          <div className="controls" style={{ marginBottom: '20px' }}>
            <button 
              className="btn btn-primary" 
              onClick={fetchClientData}
              disabled={loading}
              style={{ marginRight: '10px' }}
            >
              {loading ? 'Loading...' : 'Refresh Frame'}
            </button>
            
            <button 
              className={`btn ${isPolling ? 'btn-success' : 'btn-outline-success'}`}
              onClick={togglePolling}
            >
              {isPolling ? 'Stop Live Updates' : 'Start Live Updates'}
            </button>
          </div>

          {error && (
            <div className="alert alert-warning">
              <strong>Notice:</strong> {error}
            </div>
          )}

          {imageFrame && (
            <div className="image-display">
              <h4>Latest Frame</h4>
              <div className="frame-container" style={{ 
                border: '2px solid #ddd', 
                borderRadius: '8px', 
                padding: '10px',
                backgroundColor: '#f8f9fa',
                display: 'inline-block'
              }}>
                <img
                  src={imageFrame}  
                  alt="Latest frame from server"
                  style={{
                    maxWidth: '100%',
                    maxHeight: '500px',
                    display: 'block',
                    borderRadius: '4px'
                  }}
                  onError={() => setError('Failed to load image frame')}
                />
              </div>
              <p className="text-muted" style={{ marginTop: '10px' }}>
                {isPolling ? 'Live updates active' : 'Static frame - click refresh for latest'}
              </p>
            </div>
          )}

          {!loading && !error && !imageFrame && (
            <div className="alert alert-info">
              <h4>No frame data available</h4>
              <p>Start the video analysis on the main page to see frames here.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default ClientPage;